import { docReady } from './doc-ready';
const initImageObserver = () => {
    Array.from(document.querySelectorAll('[data-image-observer]')).map((instance) => {
        const sources = Array.from(instance.querySelectorAll('source'));
        const imgTag = instance.querySelector('img');
        const threshold = 0.1;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !imgTag.srcset) {
                    sources.map((source) => {
                        source.srcset = source.dataset.srcset;
                        imgTag.srcset += source.dataset.srcset;
                    });
                }
            });
        }, {
            root: null,
            rootMargin: '20px',
            threshold: threshold,
        });
        observer.observe(imgTag);
    });
};
docReady(() => {
    initImageObserver();
});
export { initImageObserver };
